// src/utils/auth.js

export const getAuthToken = () => {
    // Cette fonction lit le token depuis le localStorage.
    // C'est la même source que celle que votre Navbar ou d'autres composants utilisent.
    return localStorage.getItem('token');
};